import { z } from 'zod';
import { useSourceStore } from '@/stores/SourceStore.ts';

const InputSourceSchema = z.object({
    id: z.string(),
    name: z.string(),
    thumbnail: z.string(),
});

const StoreSyncSourceValueSchema = z.object({
    sources: z.array(InputSourceSchema),
    selectedSourceId: z.string().nullable(),
    selectedSourceName: z.string().nullable(),
});

export const storeSyncSourceHandler = (rawValue: object) => {
    const value = StoreSyncSourceValueSchema.parse(rawValue);

    const sourceStore = useSourceStore();
    sourceStore.$patch({
        sources: value.sources,
        selectedSourceId: value.selectedSourceId,
        selectedSourceName: value.selectedSourceName,
    });
};
